<template>
 <v-container class="mt-2 productContainer">
    <v-row>
        <v-col cols="12">
          <strong>
            <h3>Our Retailers</h3>
          </strong>
        </v-col>
    </v-row>

    <v-row>
        <v-col cols="12" md="4" v-for="(item, index) in allRetailers.reverse()" :key="index" >
           
             <v-card
              class="mx-auto my-1"
              max-width="auto"
            >
              <template slot="progress">
                <v-progress-linear
                  color="deep-purple"
                  height="10"
                  indeterminate
                ></v-progress-linear>
              </template>

              <v-card-title>{{item.companyName}}</v-card-title>
              <v-card-text class="text-subtitle-1">
                  • {{item.User.address}}<br/>
                  • {{item.User.state}}, {{item.User.country}}
                <div>{{item.description}}</div>
              </v-card-text>

              <v-card-text>
                <v-btn
                        align="center"
                        color="#000000"
                        style="color:#ffffff;"
                        :to="'/store/0/' + item.User.userId"
                      >
                      Store
                      </v-btn>

              </v-card-text>

            </v-card>
        </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Retailers",

  data: () => ({
    allRetailers:[]
  }),
  created() {
    this.fetchRetailers();
  },
  methods: {
    fetchRetailers() {
      this.$http
        .get(`${process.env.VUE_APP_URL}retailers`)
        .then((response) => {
          this.allRetailers = response.data.data;
        });
    },
  },
};
</script>

<style scoped>
.productContainer {
  background-color: #f2f2f2;
  border-radius: 10px;
  padding: 50px;
}

.text-subtitle-1{
  font-size:12px !important;
}
</style>
